/**
 * Init Mobile Navigation
 */
const initMobileNavigation = () => {
	const $mobileNavigationTrigger = $('.nav-trigger');
	const $mobileNavigationContainer = $('.header__content');

	$mobileNavigationTrigger.on('click', function(event) {
		event.preventDefault();

		$(this).toggleClass('is--active');

		$mobileNavigationContainer.toggleClass('is--active');

    $('body').toggleClass('no-scroll');
	});
}

initMobileNavigation();
